module.exports = __webpack_public_path__ + "img/eritrea.bda1341.webp";